import React from 'react';
import StartScreen from '../components/quiz/StartScreen';

const Home = ({ onStart }) => {
  return <StartScreen onStart={onStart} />;
};

export default Home;